import { Component } from 'react'
import PropTypes from 'prop-types'
import es6Promise from 'es6-promise'

es6Promise.polyfill() // polyfill older browsers that don't have promise support

export class AsyncPoller extends Component {
  constructor(props) {
    super(props)
    this.poller = null
    this.attemptCount = 0
    this.totalTime = 0
  }

  componentDidMount() {
    if (this.props.url) {
      this.poll()
    }
  }

  componentDidUpdate(prevProps) {
    const { url } = this.props
    if (prevProps.url !== url) {
      clearTimeout(this.poller)
      if (url) {
        this.poll()
      }
    }
  }

  render() {
    return <div>{this.props.children}</div>
  }

  nextDelay() {
    let wait
    if (this.props.backoff) {
      // Every 5 attempts, exponentially increase the wait time between polls
      wait =
        (this.props.delay / 1000) ** Math.ceil(this.attemptCount / 5) * 1000
    } else {
      wait = this.props.delay
    }
    this.totalTime += wait
    return wait
  }

  poll() {
    if (this.props.giveUpAfter && this.totalTime >= this.props.giveUpAfter) {
      this.props.onGiveUp && this.props.onGiveUp()
      return
    }

    this.attemptCount += 1

    this.poller = setTimeout(() => {
      fetch(this.props.url).then((response) => {
        // TODO - check for expected data format so we could also use this to
        // show progress, rather than just a final result
        if (response.status >= 200 && response.status < 300) {
          this.props.onComplete &&
            response.json().then((data) => this.props.onComplete(data))
        } else {
          this.poll()
        }
      })
    }, this.nextDelay())
  }
}

AsyncPoller.propTypes = {
  backoff: PropTypes.bool,
  delay: PropTypes.number,
  giveUpAfter: PropTypes.number,
  onComplete: PropTypes.func.isRequired,
  onGiveUp: PropTypes.func,
  url: PropTypes.string,
}

AsyncPoller.defaultProps = {
  backoff: true,
  delay: 2000,
}
